<template>
  <div class="field-wrapper-wuk sword-radio-wuk" :class="{'--bg-fill': fillBg }">
    <base-input type="radio"
                :name="name"
                :id="uniqueId"
                v-model="modelValue"
                :opt-value="optValue"
                :required="required"
                :disabled="disabled"
                :validation="validation"/>
    <label :for="uniqueId" class="t3 -t_medium sword-radio-label-display" :class="{ icon }">
      <div v-if="icon" class="sword-icon-box">
        <slot name="icon">
          <sword-icon-wuk :name="icon" />
        </slot>
      </div>
      <span>
        <slot></slot>
      </span>
    </label>
  </div>
</template>

<script>

import inputHandler from '@ui-kit/mixins/inputHandler';
import BaseInput from '@ui-kit/components/inputs/BaseInput.vue';
import SwordIconWuk from '@ui-kit/components/icons/SwordIcon.vue';

export default {
  name: 'SwordRadioWuk',
  mixins: [inputHandler],
  components: { BaseInput, SwordIconWuk },
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: {
      type: [String, Number],
      required: true,
    },
    optValue: {
      type: [String, Number],
      required: true,
    },
    name: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    icon: {
      type: String,
      default: null,
    },
  },
  computed: {
    modelValue: {
      get() {
        return this.checked;
      },
      set(val) {
        this.$emit('change', val);
      },
    },
  },
};
</script>
